"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyThousandSeparator = applyThousandSeparator;
exports.formatCurrencyValue = formatCurrencyValue;
function applyThousandSeparator(num, fix) {
    if (isNaN(num)) {
        num = 0.0;
    }
    fix = fix || 0;
    if (num === null) {
        return '0';
    }
    if (!Number.isInteger(num)) {
        num = Number(num).toFixed(fix);
    }
    else {
        num = String(num);
    }
    return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1,`);
}
const validateCurrencyLocale = (currencyCode) => {
    switch (currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toLowerCase()) {
        case 'jpy':
        case '¥':
            return { locale: 'ja-JP', status: false };
        case 'irr':
            return { locale: 'fa-IR', status: false };
        case 'krw':
        case '₩':
            return { locale: 'ko-KR', status: true };
        case 'kmf':
        case 'cf':
            return { locale: 'fr-KM', status: false };
        case 'pyg':
        case '₲':
            return { locale: 'es-PY', status: false };
        case 'rwf':
        case 'frw':
            return { locale: 'fr-RW', status: false };
        case 'ugx':
        case 'ush':
            return { locale: 'en-UG', status: false };
        case 'vuv':
        case 'vt':
            return { locale: 'en-VU', status: false };
        case 'vnd':
        case '₫':
            return { locale: 'vi-VN', status: false };
        case 'xaf':
        case 'fcfa':
            return { locale: 'fr-CM', status: false };
        case 'xof':
        case 'cfa':
            return { locale: 'fr-SN', status: false };
        case 'xpf':
        case '₣':
            return { locale: 'fr-PF', status: false };
        case 'kwd':
        case 'د.ك':
            return { locale: 'ar-KW', status: false };
        case 'jod':
        case 'د.ا':
            return { locale: 'ar-JO', status: false };
        case 'bhd':
        case '.د.ب':
            return { locale: 'ar-BH', status: false };
        case 'iqd':
        case 'ع.د':
            return { locale: 'ar-IQ', status: false };
        case 'lyd':
        case 'ل.د':
            return { locale: 'ar-LY', status: false };
        case 'tnd':
        case 'د.ت':
            return { locale: 'ar-TN', status: false };
        case 'aed':
        case 'د.إ':
            return { locale: 'ar-AE', status: false };
        case 'usd':
        case '$':
            return { locale: 'en-US', status: false };
        case 'gbp':
        case '£':
            return { locale: 'en-GB', status: false };
        case 'aud':
        case 'a$':
            return { locale: 'en-AU', status: false };
        case 'brl':
        case 'r$':
            return { locale: 'pt-BR', status: false };
        case 'sar':
        case '﷼':
            return { locale: 'ar-SA', status: false };
        case 'qar':
            return { locale: 'ar-QA', status: false };
        case 'omr':
            return { locale: 'ar-OM', status: false };
        case 'myr':
        case 'rm':
            return { locale: 'ms-MY', status: false };
        case 'hkd':
        case 'hk$':
            return { locale: 'zh-HK', status: false };
        case 'thb':
        case '฿':
            return { locale: 'th-TH', status: false };
        case 'sgd':
        case 's$':
            return { locale: 'en-SG', status: false };
        case 'eur':
        case '€':
            return { locale: 'fr-FR', status: false };
        case 'try':
        case '₺':
            return { locale: 'tr-TR', status: false };
        default:
            return { locale: 'en-US', status: false };
    }
};
exports.default = validateCurrencyLocale;
function formatCurrencyValue(val, { cs = '', currencyPrecision = 2, currencyCommaSeparator = 'disable' }) {
    var _a, _b, _c;
    if (!val) {
        return null;
    }
    const { locale, status } = validateCurrencyLocale(cs);
    if (status && currencyCommaSeparator === 'enable') {
        return (_a = Number(val)) === null || _a === void 0 ? void 0 : _a.toLocaleString(locale, {
            minimumFractionDigits: currencyPrecision,
            maximumFractionDigits: currencyPrecision,
        });
    }
    if (val === '0') {
        if (currencyPrecision === 0) {
            return String(Number(val).toLocaleString('en-US'));
        }
        return String((_b = Number(val)) === null || _b === void 0 ? void 0 : _b.toLocaleString('en-US', {
            minimumIntegerDigits: currencyPrecision,
            minimumFractionDigits: currencyPrecision,
        }));
    }
    return String((_c = Number(val)) === null || _c === void 0 ? void 0 : _c.toFixed(currencyPrecision));
}
